export const EMBED_PROVIDERS = {
  youtube: 'youtube',
  vimeo: 'vimeo',
};

export function detectEmbedProvider(url) {
  if (!url || typeof url !== 'string') return null;
  if (/youtube\.com|youtu\.be/i.test(url)) return EMBED_PROVIDERS.youtube;
  if (/vimeo\.com/i.test(url)) return EMBED_PROVIDERS.vimeo;
  return null;
}

export function parseYouTubeId(url) {
  if (!url) return null;
  const short = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (short) return short[1];
  const watch = url.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
  if (watch) return watch[1];
  const embed = url.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);
  if (embed) return embed[1];
  return null;
}

export function parseVimeoId(url) {
  if (!url) return null;
  const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return match ? match[1] : null;
}

export function getEmbedIframeSrc(provider, url, playback = {}) {
  const p = provider || detectEmbedProvider(url);
  if (!p || !url) return null;

  const pb = playback || {};
  const autoplay = pb.autoplay ? 1 : 0;
  const muted = pb.muted === true || pb.autoplay ? 1 : 0;
  const loop = pb.loop ? 1 : 0;
  const controls = pb.controls === false ? 0 : 1;

  if (p === EMBED_PROVIDERS.youtube) {
    const id = parseYouTubeId(url);
    if (!id) return null;
    const params = new URLSearchParams({
      rel: '0',
      autoplay: String(autoplay),
      mute: String(muted),
      controls: String(controls),
      playsinline: '1',
    });
    if (loop) {
      params.set('loop', '1');
      params.set('playlist', id);
    }
    /* Ouvre le canal de pilotage du lecteur, **toujours** et non selon le
       consentement : le rendu du site doit être identique, suivi accepté ou
       refusé, et un iframe dont l'URL diffère n'est plus le même rendu. Le
       paramètre ne transmet rien par lui-même — il autorise un dialogue que
       seul notre script engage, et ce script n'est branché qu'avec l'accord du
       lecteur (`videoPlayerBridge.js`). */
    params.set('enablejsapi', '1');
    // Exigé par l'API : sans `origin`, le lecteur refuse les messages.
    if (typeof window !== 'undefined') params.set('origin', window.location.origin);
    return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`;
  }
  if (p === EMBED_PROVIDERS.vimeo) {
    const id = parseVimeoId(url);
    if (!id) return null;
    const params = new URLSearchParams({
      autoplay: String(autoplay),
      muted: String(muted),
      loop: String(loop),
      controls: String(controls),
    });
    // Même raison que pour YouTube : posé quel que soit le choix du lecteur.
    params.set('api', '1');
    return `https://player.vimeo.com/video/${id}?${params.toString()}`;
  }
  return null;
}

export function getEmbedThumbnail(provider, url) {
  const p = provider || detectEmbedProvider(url);
  if (p === EMBED_PROVIDERS.youtube) {
    const id = parseYouTubeId(url);
    return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
  }
  return null;
}
